import React from 'react';

interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  background?: 'background' | 'card';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function Section({
  id,
  className = '',
  children,
  background = 'background',
  padding = 'lg'
}: SectionProps) {
  // Mobile-first responsive padding with better mobile optimization
  const paddingClasses = {
    sm: 'py-8 md:py-12',
    md: 'py-12 md:py-16 lg:py-20',
    lg: 'py-16 md:py-24 lg:py-32',
    xl: 'py-20 md:py-32 lg:py-40'
  };

  const backgroundClasses = {
    background: 'bg-background',
    card: 'bg-card'
  };

  return (
    <section
      id={id}
      className={`${paddingClasses[padding]} ${backgroundClasses[background]} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {children}
      </div>
    </section>
  );
}

